/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxcode.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-code";

export class AutogenModelExcisetaxcode<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxcodeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxcode extends ModelRow<RowExcisetaxcodeFields> {
	constructor(values?: Partial<RowExcisetaxcodeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxcodeFields {
	company_id: string;
	descr: string;
	edi_code: string;
	glid: string;
	id: string;
	include_other_tax: string;
	is_active: string;
}

